@if (isCustomerView()) {
    <app-customer-order-dashboard></app-customer-order-dashboard>
} @else {
    <app-order-fulfillment></app-order-fulfillment>
}
